import ReactDOM from 'react-dom/client';
import "tw-elements-react/dist/css/tw-elements-react.min.css";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { GOOGLE_CLIENT_ID } from './api-services/process';
import './assets/css/index.css';
import App from './App';
import { ThemeProvider } from './context/theme-context';

// Get the root element
const rootElement = document.getElementById('root');
const initialLoader = document.getElementById('initial-loader');

// Function to hide initial loader with animation
const hideInitialLoader = () => {
  if (initialLoader) {
    initialLoader.classList.add('hidden');
    // Remove from DOM after animation completes
    setTimeout(() => {
      if (initialLoader.parentNode) {
        initialLoader.remove();
      }
    }, 300);
  }
};

// Function to show root content with fade in
const showRootContent = () => {
  if (rootElement) {
    rootElement.classList.add('visible');
  }
};

// Apply saved theme preference IMMEDIATELY to prevent white flash
// This runs before React even loads
const applyThemeImmediately = () => {
  try {
    const savedTheme = localStorage.getItem('theme');
    const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    const isDarkMode = savedTheme === 'dark' || (!savedTheme && systemPrefersDark);
    
    if (isDarkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  } catch (error) {
    console.error('Error applying theme:', error);
  }
};

// Apply theme before anything else
applyThemeImmediately();

// Create a client
const queryClient = new QueryClient();
const clientId = GOOGLE_CLIENT_ID;

// Render the app
const root = ReactDOM.createRoot(rootElement as HTMLElement);

root.render(
  <QueryClientProvider client={queryClient}>
    <GoogleOAuthProvider clientId={clientId || ''}>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </GoogleOAuthProvider>
    {/* <ReactQueryDevtools initialIsOpen={false} /> */}
  </QueryClientProvider>,
);

// Hide loader and show content after React mounts
// Use requestAnimationFrame to ensure this happens after the first paint
requestAnimationFrame(() => {
  hideInitialLoader();
  showRootContent();
});

reportWebVitals();

// Event listeners for copy protection
document.addEventListener('copy', function(event) {
  event.preventDefault();
});

document.addEventListener('cut', function(event) {
  event.preventDefault();
});

// Optional: Add listener for theme changes from localStorage
// This helps if theme changes in another tab
window.addEventListener('storage', (event) => {
  if (event.key === 'theme') {
    const isDarkMode = event.newValue === 'dark';
    if (isDarkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }
});